import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

//components
import SenderDetails from "./SenderDetails";
import ReceiverDetails from "./ReceiverDetails";
import TransferAmount from "./TransferAmount";
import GenerateReceipt from "./GenerateReceipt";
import { useLocation } from "react-router-dom";
import { DataManagerContext } from "../../../context/DataManagerContext";
import "../step.css";
import { TransferContext } from "../../../context/TransferContext";
import { AuthContext } from "../../../context/AuthContext";
import RefreshToken from "../../../components/RefreshToken";

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  active: {
    "& $line": {
      borderColor: "#35B522",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#35B522",
    },
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },

  active: {
    color: "#35B522",
    boxShadow: "0 4px 10px 0 #35B52270",
    borderRadius: "50%",
  },
  circle: {
    position: "relative",
    width: 32,
    height: 32,
    borderRadius: "50%",
    border: "3px solid currentColor",
  },
  circle2: {
    position: "absolute",
    width: 26,
    height: 26,
    borderRadius: "50%",
    backgroundColor: "currentColor",
    border: "3px solid white",
  },
  circle3: {
    position: "relative",
    width: 32,
    height: 32,
    borderRadius: "50%",
    border: "3px solid #35B522",
  },
  circle4: {
    position: "absolute",
    width: 26,
    height: 26,
    borderRadius: "50%",
    backgroundColor: "#35B522",
    border: "3px solid white",
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <div className={classes.circle3}>
          <div className={classes.circle4}></div>
        </div>
      ) : (
        <div className={classes.circle}>
          <div className={classes.circle2}></div>
        </div>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  //Stepper Design
  root: {
    width: "100%",
    "& .MuiStepper-root": {
      padding: "24px 0px",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  marginTopStyle: {
    marginBottom: "30px",
  },
}));

function getSteps() {
  return [
    "Sender Details",
    "Receiver Details",
    "Transfer Amount",
    "Generate Receipt",
  ];
}

const MoneyPickedStepper = ({ setTitle }) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  let location = useLocation();
  const { setDataManager } = useContext(DataManagerContext);

  const { transfer, removeTransfer } = useContext(TransferContext);
  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  let path = location.pathname;
  const steps = getSteps();
  function getStepContent(step) {
    switch (step) {
      case 0:
        return <SenderDetails />;
      case 1:
        return <ReceiverDetails />;
      case 2:
        return <TransferAmount />;
      default:
        return <GenerateReceipt />;
    }
  }
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleTransfer = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    let data = {
      countryId: transfer.countryId,
      collectionPoint: transfer.collectionPoint,
      transaction: {
        fromCurrency: transfer.fromCurrency,
        amountToTransfer: transfer.amountToTransfer,
        toCurrency: transfer.toCurrency,
      },
      sender: {
        fullName: transfer.name,
        documentId: transfer.documentId,
        documentNumber: transfer.documentNumber,
        mobileNumber: transfer.mobileNumber,
        address: transfer.address,
      },
      receiver: {
        fullName: transfer.r_name,
        documentId: transfer.r_documentId,
        documentNumber: transfer.r_documentNumber,
        mobileNumber: transfer.r_mobileNumber,
      },
    };

    try {
      let res = await axios({
        url: `/api/v1/private/transfer/agent/receive-in-cash`,
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("send", res.data.data);
      removeTransfer(res.data.data);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } catch (error) {
      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (path === "/money-picked") {
      if (activeStep === 3) {
        setTitle("Money Transfer has been successful");
      } else {
        setTitle("Transfer Method: Cash Pickup");
      }
    }
    let data = {
      step: activeStep,
    };
    setDataManager(data);
  }, [activeStep]);

  return (
    <div className={classes.root}>
      

      {loading ? <LinearProgress /> : null}

      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={classes.instructions}>
              All steps completed - you&apos;re finished
            </Typography>
            <Button onClick={handleReset} className={classes.button}>
              Reset
            </Button>
          </div>
        ) : (
          <div>
            {getStepContent(activeStep)}

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              {/* <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                className={classes.button}
              >
                Back
              </Button> */}
              {activeStep === steps.length - 1 ? null : (
                <div>
                  {activeStep === steps.length - 2 ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleTransfer}
                      className={classes.buttonStyle}
                    >
                      Confirm Transfer
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.buttonStyle}
                    >
                      Next
                    </Button>
                  )}

                  <Button
                    onClick={handleReset}
                    color="primary"
                    style={{
                      position: "absolute",
                      top: 90,
                      right: 65,
                      fontWeight: 700,
                    }}
                  >
                    Change
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default MoneyPickedStepper;
